import React, { useEffect, useState } from 'react';
import ManagerService from '../../services/ManagerService';
import ReactPlayer from 'react-player';
import Select from 'react-select';

const CameraComponent = () => {
    const [cameras, setCameras] = useState([]);
    const [selectedCameras, setSelectedCameras] = useState([]);

    useEffect(() => {
        const fetchCameras = async () => {
            try {
                const data = await ManagerService.getCameras();
                setCameras(data);
            } catch (error) {
                console.error('Lỗi khi lấy dữ liệu camera:', error);
            }
        };
        fetchCameras();
    }, []);

    // Lọc ra chỉ những camera có link stream hợp lệ
    const validCameras = cameras.filter(camera => camera.link_stream !== "no stream");

    // Chuyển đổi dữ liệu thành định dạng cho react-select
    const cameraOptions = validCameras.map(camera => ({
        value: camera.ID,
        label: camera.ten_camera
    }));

    const handleCameraSelect = (selectedOptions) => {
        setSelectedCameras(selectedOptions || []);
    };

    const handleWatchCameras = () => {
        console.log("Cameras selected:", selectedCameras);
        // Thực hiện hành động khác nếu cần
    };

    return (
        <div className="container mt-4">
            <h1>Chọn Camera</h1>
            <Select
                options={cameraOptions}
                isMulti
                onChange={handleCameraSelect}
                placeholder="Chọn camera..."
                className="mb-4"
            />
            <div className="mt-4">
                {selectedCameras.length > 0 && (
                    <h2>Xem camera đã chọn:</h2>
                )}
                <div className="row">
                    {selectedCameras.map(selectedCamera => {
                        const camera = validCameras.find(cam => cam.ID === selectedCamera.value);
                        return camera ? (
                            <div key={camera.ID} className="col-md-3 mb-4">
                                <div style={styles.playerContainer}>
                                    <h3>{camera.ten_camera}</h3>
                                    <ReactPlayer
                                        url={camera.link_stream}
                                        controls
                                        playing={true} // Tự động phát video
                                        width="100%"
                                        height="100%"
                                        style={styles.videoPlayer} // Style cho player
                                    />
                                </div>
                            </div>
                        ) : null;
                    })}
                </div>
            </div>
        </div>
    );
};

// Style để điều chỉnh tỷ lệ 16:9 cho player
const styles = {
    playerContainer: {
        position: 'relative',
        paddingTop: '56.25%', // Tỷ lệ 16:9
        height: 0,
        overflow: 'hidden',
    },
    videoPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
};

export default CameraComponent;
